import React, { useEffect, useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Button } from '@material-ui/core'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(({ palette, ...theme }) => ({
    dialog: {
        borderRadius: '20px',
        width: '400px',
        color: 'white',
    },
    header: {
        backgroundColor: '#4d4dff',
    },
    cancel: {
        backgroundColor: '#616161',
        color: 'white',
        marginBottom: '10px',
        margin: '5px',
        '&:hover': {
            backgroundColor: '#616161',
        },
    },
    submit: {
        backgroundColor: '#ff9200',
        color: 'white',
        marginBottom: '10px',
        margin: '5px',
        '&:hover': {
            backgroundColor: '#ff9200',
        },
    },
    input: {
        '& input[type=number]': {
            '-moz-appearance': 'textfield',
        },
        '& input[type=number]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
        '& input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
    },
}))

function VerifyOTP(props) {
    const [counter, setCounter] = useState(30)

    const useCountDown = () => {
        useEffect(() => {
            if (counter === 0) {
                return
            }
            let timer1 = setTimeout(() => {
                setCounter(counter - 1)
            }, 1000)
            return () => {
                clearTimeout(timer1)
            }
        }, [counter])
        return counter
    }

    function Countdown({ seconds }) {
        const timeLeft = useCountDown(seconds)
        return (
            <div style={{ color: 'gray', padding: '20px' }}>
                {counter === 0
                    ? 'Resend OTP now'
                    : 'Resend OTP in ' + timeLeft + 's'}
            </div>
        )
    }

    const classes = useStyles()
    const [otpData, updateOTPData] = useState({
        resendOtp: false,
        enteredOtp: '',
    })

    // handler for otp dialog
    const [open, setOpen] = useState(props.open)

    const clearOtpState = () => {
        let otpState = { ...otpData }
        otpState.enteredOtp = ''
        otpState.resendOtp = false
        updateOTPData(otpState)
    }

    const handleClose = () => {
        setOpen(false)
        clearOtpState()
        if (props.onOTPCancel) props.onOTPCancel()
    }
    //end

    const handleChange = ({ target: { name, value } }) => {
        let temp = { ...otpData }
        temp[name] = value
        updateOTPData(temp)
    }

    const handleSubmit = async () => {
        if (otpData.enteredOtp !== '') {
            clearOtpState()
            if (props.onOTPSubmit) props.onOTPSubmit(otpData)
        }
    }

    const handleResendOTP = async () => {
        clearOtpState()
        if (props.onResendOTP) props.onResendOTP()
        setCounter(30)
    }

    return (
        <>
            {/* dialog for otp */}

            <Dialog
                PaperProps={{ classes: { root: classes.dialog } }}
                onClose={(event, reason) => {
                    if (
                        reason !== 'backdropClick' &&
                        reason !== 'escapeKeyDown'
                    ) {
                        handleClose(event, reason)
                    }
                }}
                open={props.open}
                aria-labelledby="form-dialog-title"
            >
                <ValidatorForm onSubmit={handleSubmit}>
                    <DialogTitle
                        className={classes.header}
                        id="form-dialog-title"
                    >
                        Enter OTP
                    </DialogTitle>
                    <DialogContent>
                        <TextValidator
                            onKeyDown={(ev) => {
                                if (ev.key === 'Enter') {
                                    handleSubmit()
                                }
                            }}
                            fullWidth
                            onInput={(e) => {
                                e.target.value = e.target.value
                                    .toString()
                                    .slice(0, 6)
                            }}
                            className={classes.input}
                            size="small"
                            variant="outlined"
                            margin="normal"
                            onChange={handleChange}
                            id="enteredOtp"
                            label="OTP"
                            name="enteredOtp"
                            autoComplete="off"
                            autoFocus
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault()
                                }
                            }}
                            value={otpData.enteredOtp}
                            validators={['required', 'maxStringLength:6']}
                            errorMessages={[
                                'OTP is required',
                                'OTP is not valid',
                            ]}
                            FormHelperTextProps={{
                                className: classes.text,
                            }}
                        />
                    </DialogContent>
                    <center>
                        <Button
                            type="submit"
                            className={classes.submit}
                            onClick={handleSubmit}
                        >
                            VERIFY
                        </Button>
                        <Button
                            disabled={counter === 0 ? false : true}
                            className={classes.submit}
                            onClick={handleResendOTP}
                            color="primary"
                        >
                            Resend OTP
                        </Button>

                        <Button
                            onClick={handleClose}
                            className={classes.cancel}
                        >
                            CANCEL
                        </Button>
                        <Countdown seconds={30} />
                    </center>
                </ValidatorForm>
            </Dialog>

            {/* end */}
        </>
    )
}
export default VerifyOTP
